﻿<div class="ef-page">

  <!-- ── HEADER ─────────────────────────────────────────────── -->
  <div class="ef-header">
    <div class="ef-header__icon"><mat-icon>payment</mat-icon></div>
    <div>
      <h1 class="ef-header__title">{{ preinvoice.uid ? 'Editar gasto' : 'Nuevo gasto' }}</h1>
      <p class="ef-header__sub">{{ preinvoice.uid ? 'Modifica los datos del gasto' : 'Registra un nuevo gasto' }}</p>
    </div>

    <div class="ef-header__summary" *ngIf="ready && preinvoice.invoiceLines?.length > 0">
      <div class="ef-header__summary-item">
        <span class="ef-header__summary-label">Subtotal</span>
        <span class="ef-header__summary-value">{{ calcularSubtotal() }}</span>
      </div>
      <div class="ef-header__summary-divider"></div>
      <div class="ef-header__summary-item">
        <span class="ef-header__summary-label">Total</span>
        <strong class="ef-header__summary-value ef-header__summary-value--total">{{ calcularTotal() }}</strong>
      </div>
    </div>

    <button mat-flat-button class="ef-btn-save"
      [disabled]="(expenseService.saveRequestObservable$ | async) || attachmentUploading"
      (click)="save(preinvoice)">
      <mat-icon>save</mat-icon> Guardar
    </button>
  </div>

  <!-- ── BODY ───────────────────────────────────────────────── -->
  <div class="ef-body" *ngIf="ready">
    <div class="ef-grid">

      <!-- COLUMNA IZQUIERDA -->
      <div class="ef-left">

        <!-- SECCIÓN: Emisor y fechas -->
        <div class="ef-section">
          <div class="ef-section__head">
            <mat-icon>business</mat-icon>
            <span>Emisor y fechas</span>
            <div class="ef-section__head-extra">
              <button mat-stroked-button class="ef-btn-secondary" (click)="newContact(true)">
                <mat-icon>person_add</mat-icon> Nuevo contacto
              </button>
              <span *ngIf="(newContactLoaded | async) === null" class="ef-warn-text">
                No se pudo actualizar la lista
              </span>
            </div>
          </div>
          <div class="ef-section__body">

            <!-- Emisor -->
            <div class="ef-field-with-help">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Emisor</mat-label>
                <input matInput [(ngModel)]="preinvoice.issuerName" name="preinvoice.issuerName"
                  [matAutocomplete]="auto" [formControl]="contactCtrl" required [readonly]="readOnly"
                  matTooltip="Recuerda seleccionar el contacto de la lista">
                <mat-autocomplete #auto="matAutocomplete"
                  (optionSelected)="verifyDuplicateIssuerName($event.option.value)">
                  <mat-option *ngFor="let contact of filteredContacts | async; trackBy: trackByIndex" [value]="contact.companyName">
                    {{ contact.companyName }}
                  </mat-option>
                </mat-autocomplete>
                <mat-icon matSuffix class="cf-spin-icon" *ngIf="(newContactLoaded | async) === false">autorenew</mat-icon>
              </mat-form-field>
              <app-help key="Gastos22"></app-help>
            </div>

            <!-- Actividades (condicional) -->
            <ng-container *ngIf="preinvoice.uid == null && contactSelected?.isProvider && contactSelected?.contactActivities?.length > 1">
              <p class="ef-subsection-label">Asignación del gasto por actividad</p>
              <div class="ef-activity-grid">
                <mat-form-field *ngFor="let activity of contactSelected.contactActivities; trackBy: trackByIndex" appearance="outline">
                  <mat-label>% en {{ activity.activityName }}</mat-label>
                  <input matInput type="number" min="0" max="100" [(ngModel)]="activity.percentage"
                    [ngModelOptions]="{standalone: true}">
                  <span matSuffix>%</span>
                </mat-form-field>
              </div>
            </ng-container>

            <!-- Fechas -->
            <div class="ef-two-col">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Fecha factura</mat-label>
                <input matInput [matDatepicker]="invoiceRelease" name="preinvoice.invoiceRelease"
                  [(ngModel)]="preinvoice.invoiceRelease"
                  (dateInput)="setExpiration($event)" (dateChange)="setExpiration($event)" required>
                <mat-datepicker-toggle matSuffix [for]="invoiceRelease"></mat-datepicker-toggle>
                <mat-datepicker #invoiceRelease></mat-datepicker>
              </mat-form-field>

              <div class="ef-field-with-help">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Vencimiento</mat-label>
                  <input matInput [matDatepicker]="invoiceFinish" name="preinvoice.invoiceExpiration"
                    [(ngModel)]="preinvoice.invoiceExpiration" required>
                  <mat-datepicker-toggle matSuffix [for]="invoiceFinish"></mat-datepicker-toggle>
                  <mat-datepicker #invoiceFinish></mat-datepicker>
                </mat-form-field>
                <app-help key="Gastos23"></app-help>
              </div>
            </div>

            <!-- Nº factura + Cuenta contable -->
            <div class="ef-two-col">
              <mat-form-field appearance="outline" class="w-100" [class.ef-field--duplicate]="hasDuplicateExpense">
                <mat-label>Número de factura</mat-label>
                <input type="text" matInput name="preinvoice.invoiceNumber"
                  [(ngModel)]="preinvoice.invoiceNumber" required
                  (change)="verifyDuplicateInvoiceNumber($event)" />
                <mat-hint *ngIf="hasDuplicateExpense" class="ef-hint-danger">
                  Emisor y número de factura duplicados
                </mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Cuenta contable de gasto</mat-label>
                <input matInput [(ngModel)]="preinvoice.expenseAccount" name="preinvoice.expenseAccount"
                  [matAutocomplete]="autoE" [formControl]="expenseCtrl" required>
                <mat-autocomplete #autoE="matAutocomplete">
                  <mat-option *ngFor="let account of filteredExpenses | async; trackBy: trackByIndex"
                    [value]="account.number + ' - ' + account.name">
                    {{ account.number }} — {{ account.name }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>

            <!-- Proyecto (condicional) -->
            <div class="ef-two-col" *ngIf="isProjectEnable && projects?.length > 0">
              <app-autocomplete-select [items]="projects" [(selectedItemId)]="preinvoice.projectUid"
                [idField]="'id'" [displayField]="'display'" placeholder="Proyecto" class="w-100">
              </app-autocomplete-select>
              <app-autocomplete-select [items]="expenseProjectType"
                [(selectedItemId)]="preinvoice.expenseProjectTypeUid"
                [idField]="'id'" [displayField]="'display'" placeholder="Tipo de gasto" class="w-100">
              </app-autocomplete-select>
            </div>
          </div>
        </div>

        <!-- SECCIÓN: Pago -->
        <div class="ef-section" *ngIf="preinvoice.uid == null || preinvoice.totalPaided == 0">
          <div class="ef-section__head">
            <mat-icon>credit_card</mat-icon>
            <span>Pago</span>
          </div>
          <div class="ef-section__body">

            <div class="ef-radio-row">
              <mat-radio-button [checked]="paidedCheck" color="primary" (change)="paided()" value="Pagada">
                Pagada
              </mat-radio-button>
              <mat-radio-button [checked]="noPaidedCheck" color="primary" (change)="noPaided()" value="No Pagada">
                Pendiente de pago
              </mat-radio-button>
            </div>

            <mat-form-field *ngIf="paidedCheck" appearance="outline" class="w-100">
              <mat-label>Fecha de pago</mat-label>
              <input matInput [matDatepicker]="invoicePay" name="preinvoice.paided"
                [(ngModel)]="preinvoice.paided">
              <mat-datepicker-toggle matSuffix [for]="invoicePay"></mat-datepicker-toggle>
              <mat-datepicker #invoicePay></mat-datepicker>
            </mat-form-field>

            <div class="ef-field-with-help">
              <app-autocomplete-select [items]="payMethodOptions" [(selectedItemId)]="preinvoice.typePay"
                [idField]="'value'" [displayField]="'label'" [isRequired]="true" placeholder="Tipo de pago" class="w-100">
              </app-autocomplete-select>
              <app-help key="Gastos24"></app-help>
            </div>

            <ng-container *ngIf="preinvoice.typePay === 'Efectivo'">
              <app-autocomplete-select [items]="efectivoList" [(selectedItemId)]="preinvoice.efectivoId"
                [idField]="'uid'" [displayField]="'nombre'" placeholder="Caja / Efectivo" class="w-100">
              </app-autocomplete-select>
            </ng-container>

            <ng-container *ngIf="preinvoice.typePay === 'Transferencia bancaria'
              || preinvoice.typePay === 'Cargo en cuenta'
              || preinvoice.typePay === 'Confirming'
              || preinvoice.typePay === 'Pagarés'">
              <app-autocomplete-select [items]="bankAccounts" [(selectedItemId)]="preinvoice.typePayBankAccount"
                [idField]="'uid'" [displayFields]="['bank', 'iban']" placeholder="Cuenta bancaria" class="w-100">
              </app-autocomplete-select>
            </ng-container>

            <ng-container *ngIf="preinvoice.typePay === 'Tarjeta de crédito'">
              <app-autocomplete-select [items]="paymentCards" [(selectedItemId)]="preinvoice.typePayBankAccount"
                [idField]="'uid'" [displayFields]="['name', 'number']" placeholder="Tarjeta de crédito" class="w-100">
              </app-autocomplete-select>
            </ng-container>

            <ng-container *ngIf="preinvoice.typePay === 'Tarjeta de débito'">
              <app-autocomplete-select [items]="paymentCards" [(selectedItemId)]="preinvoice.typePayBankAccount"
                [idField]="'uid'" [displayFields]="['name', 'number']" placeholder="Tarjeta de débito" class="w-100">
              </app-autocomplete-select>
            </ng-container>

            <ng-container *ngIf="preinvoice.typePay === 'Socio'">
              <app-autocomplete-select [items]="sociosList" [(selectedItemId)]="preinvoice.partnersId"
                [idField]="'uid'" [displayField]="'nameOrBusinessName'" placeholder="Socio" class="w-100">
              </app-autocomplete-select>
            </ng-container>

            <ng-container *ngIf="preinvoice.typePay === 'Póliza de crédito'">
              <app-autocomplete-select [items]="polizaCreditoList" [(selectedItemId)]="preinvoice.polizaCreditoId"
                [idField]="'uid'" [displayFields]="['banco', 'iban']" placeholder="Póliza de crédito" class="w-100">
              </app-autocomplete-select>
            </ng-container>

          </div>
        </div>

        <!-- SECCIÓN: Importes -->
        <div class="ef-section">
          <div class="ef-section__head">
            <mat-icon>receipt</mat-icon>
            <span>Importes</span>
          </div>
          <div class="ef-section__body">

            <div *ngFor="let item of preinvoice.invoiceLines; index as i; trackBy: trackByIndex" class="ef-line-wrap">
              <convfact-expense-form-item
                [taxes]="accountsAndTaxes.taxes"
                [item]="item"
                [contact]="contactSelected"
                [expenseAccount]="preinvoice.expenseAccount"
                [contactProperties]="contactProperties"
                [expenseList]="expenseList">
              </convfact-expense-form-item>
              <button mat-stroked-button class="ef-btn-remove-line" (click)="removeInvoiceLine(item)">
                <mat-icon>delete</mat-icon> Eliminar línea
              </button>
            </div>

            <div class="ef-line-actions">
              <button mat-stroked-button class="ef-btn-add-line" (click)="addInvoiceLine()">
                <mat-icon>add</mat-icon> Añadir importes
              </button>
              <button mat-stroked-button class="ef-btn-add-line" (click)="addInvoiceLineIgicImport()">
                <mat-icon>add</mat-icon> Impuesto importación
              </button>
            </div>

            <!-- Totales -->
            <div class="ef-totals" *ngIf="preinvoice.invoiceLines?.length > 0">
              <div class="ef-totals__row">
                <span class="ef-totals__label">Subtotal</span>
                <span class="ef-totals__value">{{ calcularSubtotal() }}</span>
              </div>
              <div *ngFor="let taxView of impuestos(); trackBy: trackByIndex" class="ef-totals__row">
                <span class="ef-totals__label">{{ taxView }}</span>
              </div>
              <div class="ef-totals__row ef-totals__row--final">
                <span class="ef-totals__label">Total</span>
                <strong class="ef-totals__value ef-totals__value--total">{{ calcularTotal() }}</strong>
              </div>
            </div>

          </div>
        </div>

      </div>

      <!-- COLUMNA DERECHA -->
      <div class="ef-right">

        <!-- Archivo adjunto -->
        <div class="ef-section">
          <div class="ef-section__head">
            <mat-icon>attach_file</mat-icon>
            <span>Archivo</span>
          </div>
          <div class="ef-section__body">
            <app-add-file [originEntity]="originEntity" [filePath]="filePath" [imageTempUrl]="imageTempUrl"
              [showConvfactFiles]="true" (CallbackParameters)="SetFileParameters($event)"
              (loadingChange)="onAttachmentUploadingChange($event)">
            </app-add-file>

            <div class="cf-dlg-loading" style="padding:20px 0" *ngIf="readyLoadedFiles === false">
              <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
            </div>

            <ng-container *ngIf="preinvoice.uid == null || preinvoice.totalPaided == 0">
              <app-file-data-extra [fileUid]="preinvoice.fileUid"
                (onAplicarInfo)="onAplicarInfoFicheroRelacionado($event)">
              </app-file-data-extra>
            </ng-container>
          </div>
        </div>

        <!-- Vista previa -->
        <div class="ef-section" *ngIf="imageTempUrl">
          <div class="ef-section__head">
            <mat-icon>visibility</mat-icon>
            <span>Vista previa</span>
          </div>
          <div class="ef-section__body ef-preview-body">
            <ng-container *ngIf="preinvoice.image">
              <app-image-zoom [src]="imageTempUrl"></app-image-zoom>
            </ng-container>
            <ng-container *ngIf="preinvoice.pdf">
              <div class="ef-pdf-container">
                <ngx-extended-pdf-viewer [src]="imageTempUrl" [useBrowserLocale]="true"
                  [height]="'100%'" [textLayer]="false">
                </ngx-extended-pdf-viewer>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- Observaciones -->
        <div class="ef-section">
          <div class="ef-section__head">
            <mat-icon>description</mat-icon>
            <span>Observaciones</span>
          </div>
          <div class="ef-section__body">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Observaciones / Información adicional</mat-label>
              <textarea matInput [(ngModel)]="preinvoice.comment" rows="5"></textarea>
            </mat-form-field>
          </div>
        </div>

      </div>

    </div>
  </div>

  <!-- Loading -->
  <div class="ef-loading" *ngIf="!ready">
    <div class="ef-loading__icon"><mat-icon>payment</mat-icon></div>
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
    <p class="ef-loading__text">Cargando formulario…</p>
  </div>

</div>
